import { defineMeta } from '@/registry/types';

export const alertMeta = defineMeta({
  name: 'Alert',
  level: 'molecule',
  category: 'feedback',
  classification: 'themed-mui',
  description: 'Inline contextual feedback message with severity. Themed MUI Alert.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Alert',
  muiDocs: 'https://mui.com/material-ui/react-alert/',
  a2uiEquivalent: 'Alert',
  importPath: '@/molecules/Alert',
  optionalProps: ['severity', 'variant', 'onClose', 'icon', 'action'],
  supportedStates: ['success', 'info', 'warning', 'error', 'dismissible'],
  designTokens: ['colors', 'radius', 'typography'],
  accessibility: ['Alerts use role="alert"; place near the related content.'],
  usageExamples: [
    '<Alert severity="error"><AlertTitle>Could not load findings</AlertTitle>The scanner is unreachable.</Alert>',
  ],
  rules: [
    'Use `AlertTitle` for the heading (themed as subtitle2). The message body uses the Alert body1 slot — do not wrap it in another heading variant.',
  ],
  antiPatterns: ['Do not use Alert for transient notifications (use Snackbar).'],
  llmSafe: true,
  whenToUse: ['Persistent inline status/validation messages'],
  whenNotToUse: ['Auto-dismissing toasts (use Snackbar)'],
});

export default alertMeta;
